// import React, { useState } from 'react';
// import Header from '../components/Header';
// import Footer from '../components/Footer';
// import MobileMenu from '../components/MobileMenu';
// import PopupSearch from '../components/PopupSearch';
// import ScrollToTop from '../components/ScrollToTop';

// const products = [
//   {
//     id: 1,
//     title: 'Petal Perfection',
//     price: '155.00',
//     image: '/assets/img/products5/product-1-1.png',
//     tag: 'new',
//     col: 'col-lg-3',
//   },
//   {
//     id: 2,
//     title: 'Golden Line',
//     price: '155.00',
//     image: '/assets/img/products5/product-1-2.png',
//     col: 'col-lg-3',
//   },
//   {
//     id: 3,
//     title: 'Cropped Golden Pendant',
//     price: '155.00',
//     image: '/assets/img/products5/product-1-3.png',
//     col: 'col-lg-6',
//   },
//   {
//     id: 4,
//     title: 'Cropped Golden Pendant',
//     price: '155.00',
//     image: '/assets/img/products5/product-1-4.png',
//     col: 'col-lg-6',
//   },
//   {
//     id: 5,
//     title: 'Petal Perfection',
//     price: '155.00',
//     image: '/assets/img/products5/product-1-5.png',
//     tag: 'new',
//     col: 'col-lg-3',
//   },
//   {
//     id: 6,
//     title: 'Petal Perfection',
//     price: '155.00',
//     image: '/assets/img/products6/product-1-1.png',
//     col: 'col-lg-3',
//   },
//   {
//     id: 7,
//     title: 'Petal Perfection',
//     price: '155.00',
//     image: '/assets/img/products6/product-1-2.png',
//     tag: 'new',
//     col: 'col-lg-3',
//   },
//   {
//     id: 8,
//     title: 'Petal Perfection',
//     price: '155.00',
//     image: '/assets/img/products6/product-1-3.png',
//     col: 'col-lg-3',
//   },
//   {
//     id: 9,
//     title: 'Petal Perfection',
//     price: '155.00',
//     image: '/assets/img/products6/product-1-4.png',
//     tag: 'new',
//     col: 'col-lg-3',
//   },
//   {
//     id: 10,
//     title: 'Golden Line',
//     price: '155.00',
//     image: '/assets/img/products5/product-1-5.png',
//     col: 'col-lg-3',
//   },
// ];

// const Shop: React.FC = () => {
//   const [price, setPrice] = useState(150);
//   return (
//     <>
//       <MobileMenu />
//       <PopupSearch />

//       <main className="main">
//         <Header />
//         <link rel="stylesheet" href="/assets/css/About.css" />
//         {/* BREADCUMB */}
//         <div
//           className="breadcumb-wrapper"
//           style={{
//             backgroundImage:
//               "url('/assets/img/bg/breadcumb-bg-3.jpg')",
//             backgroundRepeat: 'no-repeat',
//             backgroundPosition: 'center',
//           }}
//         >
//           <div className="container z-index-common">
//             <div className="breadcumb-content">
//               <h1 className="breadcumb-title">
//                 OUR PRODUCT
//               </h1>

//               <div className="breadcumb-menu-wrap2">
//                 <ul className="breadcumb-menu">
//                   <li>
//                     <a href="javascript:void(0)">HOME</a>
//                   </li>

//                   <li>MASONRY GRID</li>
//                 </ul>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* SHOP AREA */}
//         <section className="shop-page1 space-top space-extra-bottom z-index-common">
//           <div className="extra-shape"></div>
//           <div className='container'>
//             <div className='row'>

//               <div className="col-xl-3 col-lg-3">
//                 <aside className="shop-sidebar">

//                   {/* Price Filter */}
//                   <div className="widget">
//                     <h3 className="widget_title">
//                       Filter By
//                     </h3>


//                     <div className="title-section">
//                       <i className="fa-solid fa-bars-staggered"></i>
//                       <div className="price-heading">Price</div>
//                     </div>

//                     <div className="range-slider-area">
//                       <input
//                         type="range"
//                         min="20"
//                         max="100"
//                         value={price}
//                         className="range-slider-custom"
//                         style={{
//                           background: `linear-gradient(
//       to right,
//       #b8400e 0%,
//       #b8400e ${((price - 20) / (100 - 20)) * 100}%,
//       #e8d9c5 ${((price - 20) / (100 - 20)) * 100}%,
//       #e8d9c5 100%
//     )`,
//                         }}
//                         onChange={(e) => setPrice(Number(e.target.value))}
//                       />

//                       <div className="slider-btn mt-3">
//                         <button className="filter-btn vs-btn">
//                           Filter
//                         </button>

//                         <div className="slider-amount">
//                           Price : ₹30 - ₹{price}
//                         </div>
//                       </div>

//                       <button className="reset-btn">
//                         Clear All
//                       </button>
//                     </div>
//                   </div>

//                   {/* Category */}
//                   <div className="widget">
//                     <h3 className="widget_title">
//                       Category
//                     </h3>

//                     <div className="category-filter">
//                       <ul>

//                         <li className="category-item">
//                           <input
//                             type="checkbox"
//                             id="babys"
//                             name="babys"
//                             className="category-checkbox"
//                           />

//                           <label htmlFor="babys">
//                             Diamond watch
//                           </label>

//                           <span className="total">05</span>
//                         </li>

//                         <li className="category-item">
//                           <input
//                             type="checkbox"
//                             id="mans"
//                             name="mans"
//                             className="category-checkbox"
//                           />

//                           <label htmlFor="mans">
//                             Woman watch
//                           </label>

//                           <span className="total">08</span>
//                         </li>

//                         <li className="category-item">
//                           <input
//                             type="checkbox"
//                             id="womans"
//                             name="womans"
//                             className="category-checkbox"
//                           />

//                           <label htmlFor="womans">
//                             Pendant
//                           </label>

//                           <span className="total">14</span>
//                         </li>

//                       </ul>
//                     </div>
//                   </div>

//                   {/* Latest Products */}
//                   <div className="widget">
//                     <h3 className="widget_title">
//                       Latest Products
//                     </h3>

//                     {[1, 2, 3].map((item) => (
//                       <div
//                         className="latest-product"
//                         key={item}
//                       >
//                         <div className="media-img">
//                           <img
//                             src={`/assets/img/products5/product-1-${item}.png`}
//                             alt=""
//                           />
//                         </div>

//                         <div className="media-body">
//                           <h4 className="product-title">
//                             Diamond Ring
//                           </h4>

//                           <p className="product-price">
//                             $30.00
//                           </p>
//                         </div>
//                       </div>
//                     ))}
//                   </div>

//                   {/* Instagram */}
//                   <div className="widget">
//                     <h4 className="widget_title">
//                       Instagram
//                     </h4>

//                     <div className="sidebar-gallery">
//                       {[1, 2, 3, 4].map((img) => (
//                         <div
//                           className="gallery-thumb"
//                           key={img}
//                         >
//                           <img
//                             src={`/assets/img/widget/gal-s-1-${img}.jpg`}
//                             alt=""
//                             className="w-100"
//                           />
//                         </div>
//                       ))}
//                     </div>
//                   </div>
//                 </aside>


//               </div>
//               <div className='col-lg-9'>
//                 <div className="container">

//                   {/* SORT BAR */}
//                   <div className="vs-sort-bar style2">
//                     <div className="row gx-4 gy-3 align-items-center">

//                       <div className="col-md-auto flex-grow-1">
//                         <p className="woocommerce-result-count">
//                           <span>||</span> SHOWING 1 - 09 OF 20 RESULTS
//                         </p>
//                       </div>

//                       <div className="col-md-auto">
//                         <form className="woocommerce-ordering">
//                           <select
//                             name="orderby"
//                             className="orderby"
//                           >
//                             <option>
//                               Default Shorting
//                             </option>

//                             <option>
//                               Sort by popularity
//                             </option>

//                             <option>
//                               Sort by rating
//                             </option>

//                             <option>
//                               Sort by latest
//                             </option>

//                             <option>
//                               Sort by price: low to high
//                             </option>

//                             <option>
//                               Sort by price: high to low
//                             </option>
//                           </select>
//                         </form>
//                       </div>

//                       <div className="col-md-auto">
//                         <ul
//                           className="nav nav-tabs"
//                           role="tablist"
//                         >
//                           <li>
//                             <span className="nav-tabs-title">
//                               VIEW
//                             </span>
//                           </li>

//                           <li
//                             className="nav-item"
//                             role="presentation"
//                           >
//                             <button className="nav-link active">
//                               2
//                             </button>
//                           </li>

//                           <li
//                             className="nav-item"
//                             role="presentation"
//                           >
//                             <button className="nav-link">
//                               3
//                             </button>
//                           </li>
//                         </ul>
//                       </div>
//                     </div>
//                   </div>

//                   {/* PRODUCTS */}
//                   <div className="row gy-40">



//                     {products.map((product) => (
//                       <div
//                         className="col-lg-4 col-md-6"
//                         key={product.id}
//                       >

//                         <div className="product-style3">

//                           {/* TAG */}
//                           {product.tag && (
//                             <a
//                               href="javascript:void(0)"
//                               className="product-tag"
//                             >
//                               {product.tag}
//                             </a>
//                           )}

//                           {/* PRODUCT ACTION */}
//                           <div className="product-action">

//                             {/* Wishlist */}
//                             <button className="product-action__btn">

//                               <svg
//                                 width="18"
//                                 height="16"
//                                 viewBox="0 0 18 16"
//                                 fill="none"
//                               >
//                                 <path
//                                   d="M9.465 14.6076C9.21 14.6976 8.79 14.6976 8.535 14.6076C6.36 13.8651 1.5 10.7676 1.5 5.51757C1.5 3.20007 3.3675 1.32507 5.67 1.32507C7.035 1.32507 8.2425 1.98507 9 3.00507C9.7575 1.98507 10.9725 1.32507 12.33 1.32507C14.6325 1.32507 16.5 3.20007 16.5 5.51757C16.5 10.7676 11.64 13.8651 9.465 14.6076Z"
//                                   stroke="#6D747B"
//                                   strokeWidth="1.5"
//                                   strokeLinecap="round"
//                                   strokeLinejoin="round"
//                                 />
//                               </svg>

//                             </button>

//                             {/* View */}
//                             <button className="product-action__btn">

//                               <svg
//                                 width="20"
//                                 height="20"
//                                 viewBox="0 0 24 24"
//                                 fill="none"
//                               >
//                                 <path
//                                   d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z"
//                                   stroke="#6D747B"
//                                   strokeWidth="1.8"
//                                   strokeLinecap="round"
//                                   strokeLinejoin="round"
//                                 />

//                                 <path
//                                   d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
//                                   stroke="#6D747B"
//                                   strokeWidth="1.8"
//                                   strokeLinecap="round"
//                                   strokeLinejoin="round"
//                                 />
//                               </svg>

//                             </button>

//                           </div>

//                           {/* IMAGE */}
//                           <div className="product-img">
//                             <img
//                               className="img"
//                               src={product.image}
//                               alt={product.title}
//                             />
//                           </div>

//                           {/* CONTENT */}
//                           <div className="product-content text-center">

//                             <h3 className="product-title">
//                               <a href="/shop-details">
//                                 {product.title}
//                               </a>
//                             </h3>

//                             <span className="product-price">

//                               <span className="product-price__number">
//                                 {product.price}
//                               </span>

//                               <a
//                                 className="product-cart"
//                                 href="/cart"
//                               >
//                                 add to cart
//                               </a>

//                             </span>

//                             <div
//                               className="star-rating"
//                               role="img"
//                               aria-label="Rated 5 out of 5"
//                             >
//                               <span></span>
//                             </div>

//                           </div>

//                         </div>

//                       </div>
//                     ))}

//                   </div>


//                 </div>
//               </div>
//             </div>
//           </div>
//         </section>

//         <Footer />
//       </main>

//       <ScrollToTop />
//     </>
//   );
// };

// export default Shop;


import React, { useEffect, useMemo, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import MobileMenu from "../components/MobileMenu";
import PopupSearch from "../components/PopupSearch";
import ScrollToTop from "../components/ScrollToTop";
import { Link } from "react-router-dom";
import { getCategories, getProducts } from "./publicservice/productService";
import { Category, Product, ProductImage } from "./publicservice/interface/types";

const API_PATH = process.env.REACT_APP_API_PATH;

const Shop: React.FC = () => {
  const [products, setProducts] = useState<Product[]>([]);
  const [latestProducts, setLatestProducts] = useState<Product[]>([]);
  const [categories, setCategories] = useState<Category[]>([]);
  const [selectedCategories, setSelectedCategories] = useState<number[]>([]);
  const [price, setPrice] = useState<number>(5000);
  const [sortBy, setSortBy] = useState<string>("default");
  const [loading, setLoading] = useState<boolean>(true);
  const [menuOpen, setMenuOpen] =  useState(false);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      setLoading(true);

      const [productRes, categoryRes] = await Promise.all([
        getProducts(),
        getCategories(),
      ]);

      const productData =  productRes.dataList;
      const categoryData =  categoryRes.dataList;

      setProducts(productData);
      setLatestProducts(productData.slice(0, 3));
      setCategories(categoryData);
    } catch (error) {
      console.error("Error loading shop data:", error);
    } finally {
      setLoading(false);
    }
  };

  const getPrimaryImage = (images: ProductImage[]) => {
    const primary =
      images.find((x) => x.isPrimary) || images[0];

    return primary
      ? `${API_PATH}/uploads/${primary.imageURL}`
      : "/assets/img/no-image.png";
  };

  const handleCategoryChange = (categoryID: number) => {
    setSelectedCategories((prev) => {
      if (prev.includes(categoryID)) {
        return prev.filter((x) => x !== categoryID);
      }

      return [...prev, categoryID];
    });
  };

  const filteredProducts = useMemo(() => {
    let filtered = [...products];

    // CATEGORY FILTER
    if (selectedCategories.length > 0) {
      filtered = filtered.filter((x) =>
        selectedCategories.includes(x.categoryID)
      );
    }

    // PRICE FILTER
    filtered = filtered.filter(
      (x) => x.sellingPrice <= price
    );

    // SORTING
    switch (sortBy) {
      case "priceLow":
        filtered.sort(
          (a, b) => a.sellingPrice - b.sellingPrice
        );
        break;

      case "priceHigh":
        filtered.sort(
          (a, b) => b.sellingPrice - a.sellingPrice
        );
        break;

      case "latest":
        filtered.sort(
          (a, b) => b.productID - a.productID
        );
        break;

      case "name":
        filtered.sort((a, b) =>
          a.productName.localeCompare(b.productName)
        );
        break;
    }

    return filtered;
  }, [products, selectedCategories, price, sortBy]);

  return (
    <>
      <MobileMenu
  isOpen={menuOpen}
  onClose={() => setMenuOpen(false)}
/>
      <PopupSearch />

      <main className="main">
        <Header />
  <link rel="stylesheet" href="/assets/css/About.css" />
        {/* BREADCRUMB */}
        <div
          className="breadcumb-wrapper"
          style={{
            backgroundImage:
              "url('/assets/img/bg/breadcumb-bg-3.jpg')",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
          }}
        >
          <div className="container z-index-common">
            <div className="breadcumb-content">
              <h1 className="breadcumb-title">
                OUR PRODUCT
              </h1>

              <div className="breadcumb-menu-wrap2">
                <ul className="breadcumb-menu">
                  <li>
                    <Link to="/">HOME</Link>
                  </li>

                  <li>SHOP</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* SHOP */}
        <section className="shop-page1 space-top space-extra-bottom z-index-common">
          <div className="extra-shape"></div>

          <div className="container">
            <div className="row">
              {/* SIDEBAR */}
              <div className="col-xl-3 col-lg-3">
                <aside className="shop-sidebar">
                  {/* PRICE FILTER */}
                  <div className="widget">
                    <h3 className="widget_title">
                      Filter By
                    </h3>

                    <div className="title-section">
                      <i className="fa-solid fa-bars-staggered"></i>

                      <div className="price-heading">
                        Price
                      </div>
                    </div>

                    <div className="range-slider-area">
                      <input
                        type="range"
                        min="100"
                        max="1000000"
                        value={price}
                            style={{
  background: `linear-gradient(
    to right,
    #b8400e 0%,
    #b8400e ${((price - 100) / (1000000 - 100)) * 100}%,
    #e8d9c5 ${((price - 100) / (1000000 - 100)) * 100}%,
    #e8d9c5 100%
  )`,
}}
                        className="range-slider-custom"
                        onChange={(e) =>
                          setPrice(Number(e.target.value))
                        }
                      />

                      <div className="slider-btn mt-3">
                        <button className="filter-btn vs-btn">
                          Filter
                        </button>

                        <div className="slider-amount">
                          Price : ₹100 - ₹{price}
                        </div>
                      </div>

                      <button
                        className="reset-btn"
                        onClick={() => {
                          setPrice(5000);
                          setSelectedCategories([]);
                        }}
                      >
                        Clear All
                      </button>
                    </div>
                  </div>

                  {/* CATEGORY */}
                  <div className="widget">
                    <h3 className="widget_title">
                      Category
                    </h3>

                    <div className="category-filter">
                      <ul>
                        {categories.map((category) => (
                          <li
                            className="category-item"
                            key={category.categoryID}
                          >
                            <input
                              type="checkbox"
                              id={`cat-${category.categoryID}`}
                              checked={selectedCategories.includes(
                                category.categoryID
                              )}
                              onChange={() =>
                                handleCategoryChange(
                                  category.categoryID
                                )
                              }
                              className="category-checkbox"
                            />

                            <label
                              htmlFor={`cat-${category.categoryID}`}
                            >
                              {category.categoryName}
                            </label>

                            <span className="total">
                              {category.productCount}
                            </span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>

                  {/* LATEST PRODUCTS */}
                  <div className="widget">
                    <h3 className="widget_title">
                      Latest Products
                    </h3>

                    {latestProducts.map((product) => (
                      <div
                        className="latest-product"
                        key={product.productID}
                      >
                        <div className="media-img">
                          <img
                            src={getPrimaryImage(
                              product.images
                            )}
                            alt={product.productName}
                          />
                        </div>

                        <div className="media-body">
                          <h4 className="product-title">
                            {product.productName}
                          </h4>

                          <p className="product-price">
                            ₹{product.sellingPrice}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                </aside>
              </div>

              {/* PRODUCT AREA */}
              <div className="col-lg-9">
                {/* SORT BAR */}
                <div className="vs-sort-bar style2">
                  <div className="row gx-4 gy-3 align-items-center">
                    <div className="col-md-auto flex-grow-1">
                      <p className="woocommerce-result-count">
                        <span>||</span>
                        SHOWING{" "}
                        {filteredProducts.length} PRODUCTS
                      </p>
                    </div>

                    <div className="col-md-auto">
                      <select
                        className="orderby"
                        value={sortBy}
                        onChange={(e) =>
                          setSortBy(e.target.value)
                        }
                      >
                        <option value="default">
                          Default Sorting
                        </option>

                        <option value="name">
                          Sort By Name
                        </option>

                        <option value="latest">
                          Sort By Latest
                        </option>

                        <option value="priceLow">
                          Price: Low To High
                        </option>

                        <option value="priceHigh">
                          Price: High To Low
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                {/* PRODUCTS */}
                <div className="row gy-40">
                  {loading ? (
                    <div className="col-12 text-center">
                      Loading products...
                    </div>
                  ) : filteredProducts.length === 0 ? (
                    <div className="col-12 text-center">
                      No products found
                    </div>
                  ) : (
                    filteredProducts.map((product) => (
                      <div
                        className="col-lg-4 col-md-6"
                        key={product.productID}
                      >
                        <div className="product-style3">
                          {/* TAG */}
                          {product.isNewArrival && (
                            <span className="product-tag">
                              NEW
                            </span>
                          )}

                          {/* ACTIONS */}
                          <div className="product-action">
                            <button className="product-action__btn">
                              <i className="far fa-heart"></i>
                            </button>

                            <button className="product-action__btn">
                              <i className="far fa-eye"></i>
                            </button>
                          </div>

                          {/* IMAGE */}
                          <div className="product-img">
                            <img
                              className="img"
                              src={getPrimaryImage(
                                product.images
                              )}
                              alt={product.productName}
                            />
                          </div>

                          {/* CONTENT */}
                          <div className="product-content text-center">
                            <h3 className="product-title">
                              <Link
                                to={`/shop-details/${product.productSlug}`}
                              >
                                {product.productName}
                              </Link>
                            </h3>

                            <div className="product-price">
                              <span className="product-price__number">
                                ₹{product.sellingPrice}
                              </span>

                              <del className="ms-2">
                                ₹{product.mrp}
                              </del>
                            </div>

                   
     <ul className="badge-list d-flex align-items-center gap-4 justify-content-center list-unstyled mb-0">
  <li className="mx-5 px-3 text-mute">{product.categoryName} | {product.brandName}</li>


 
</ul>
     <ul className="badge-list d-flex align-items-center my-3 justify-content-center gap-4 list-unstyled mb-0">



  <li className="badge bg-danger">
    {product.discountPercent.toFixed(0)}% OFF
  </li>
</ul>


                         

                            <div className="mt-3">
                              <Link
                                className="product-cart product-cart-shp-page"
                                to={`/cart/${product.productID}`}
                              >
                                add to cart
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </main>

      <ScrollToTop />
    </>
  );
};

export default Shop;